/** Architectural Manual §2 — MPL-03 / MPL-04 pricing matrix. */

export const MPL03_PLAN_KEY = 'mpl03-single-course';
export const MPL04_TIER1_PLAN_KEY = 'mpl04-tier1';
export const MPL04_TIER2_PLAN_KEY = 'mpl04-tier2';

export const PRIVATE_COURSE_PRICE_AUD = 490;

export type OrgPricingTierId = 'tier1' | 'tier2';

export const ORG_PRICING_TIERS = {
  tier1: {
    id: 'tier1' as const,
    planKey: MPL04_TIER1_PLAN_KEY,
    minCourses: 1,
    maxCourses: 5,
    ratePerCourse: 450,
    label: 'Tier 1: 1 to 5 Courses @ $450 per course',
  },
  tier2: {
    id: 'tier2' as const,
    planKey: MPL04_TIER2_PLAN_KEY,
    minCourses: 5,
    maxCourses: 10,
    ratePerCourse: 400,
    label: 'Tier 2: 5 to 10 Courses @ $400 per course',
  },
} as const;

export function formatAudWhole(amount: number) {
  return `$${amount.toLocaleString('en-AU')}`;
}

export function parseOrgCourseCount(raw: string | number, tier: OrgPricingTierId): number | null {
  const count = typeof raw === 'number' ? raw : Number.parseInt(String(raw).trim(), 10);
  if (!Number.isFinite(count)) return null;

  const bounds = ORG_PRICING_TIERS[tier];
  if (count < bounds.minCourses || count > bounds.maxCourses) return null;
  return count;
}

export function calculateOrgPricingTotal(tier: OrgPricingTierId, rawCourseCount: string | number) {
  const courseCount = parseOrgCourseCount(rawCourseCount, tier);
  if (!courseCount) return null;

  const { ratePerCourse, planKey } = ORG_PRICING_TIERS[tier];
  const totalAud = courseCount * ratePerCourse;

  return {
    tier,
    planKey,
    courseCount,
    ratePerCourse,
    totalAud,
    summaryLine: `Number of students ${courseCount} × $${ratePerCourse} per Course = ${formatAudWhole(totalAud)} AUD`,
  };
}

export function isOrgPricingPlanKey(planKey: string) {
  return planKey === MPL04_TIER1_PLAN_KEY || planKey === MPL04_TIER2_PLAN_KEY;
}
